import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { ASSISTANT_EXTRA_INSTRUCTIONS_MAX_CHARACTERS } from '@/constants/assistant';

interface InstructionsFieldProps {
  fieldId: string;
  value: string;
  hint: string;
  onChange: (nextValue: string) => void;
}

export function InstructionsField({ fieldId, value, hint, onChange }: InstructionsFieldProps) {
  const { t } = useTranslation('assistant');
  return (
    <div className="space-y-1.5">
      <Label htmlFor={fieldId}>{t('configuration.instructions.label')}</Label>
      <p className="text-xs text-zoomuted">{hint}</p>
      <Textarea
        id={fieldId}
        rows={5}
        value={value}
        maxLength={ASSISTANT_EXTRA_INSTRUCTIONS_MAX_CHARACTERS}
        placeholder={t('configuration.instructions.placeholder')}
        onChange={function updateValue(changeEvent) {
          onChange(changeEvent.target.value);
        }}
      />
      <p className="text-[11px] text-zoomuted text-right">
        {t('configuration.instructions.counter', {
          count: value.length,
          maximum: ASSISTANT_EXTRA_INSTRUCTIONS_MAX_CHARACTERS,
        })}
      </p>
    </div>
  );
}
